var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 104,
    viewBox: "0 0 91 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4229 51.9118C59.7594 51.9118 71.3788 40.2925 71.3788 25.9559C71.3788 11.6193 59.7594 0 45.4229 0C31.0863 0 19.4669 11.6193 19.4669 25.9559C19.4669 40.2925 31.0863 51.9118 45.4229 51.9118ZM63.592 58.4008H60.2056C55.7038 60.4692 50.6952 61.6453 45.4229 61.6453C40.1506 61.6453 35.1622 60.4692 30.6402 58.4008H27.2537C12.2074 58.4008 0 70.6082 0 85.6545V94.0902C0 99.4639 4.35978 103.824 9.73347 103.824H81.1122C86.4859 103.824 90.8457 99.4639 90.8457 94.0902V85.6545C90.8457 70.6082 78.6383 58.4008 63.592 58.4008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4b8f36eb3c2bdd09a3115da38284f209.svg";
export { ForwardRef as ReactComponent };